import React, { useState } from 'react';
import { Eye, EyeOff } from 'lucide-react';
import { Button } from '@predoc/cow';
import { IconInput } from './IconInput';

type PasswordInputProps = Omit<
  React.ComponentProps<typeof IconInput>,
  'endIcon' | 'type'
>;

export const PasswordInput = (props: PasswordInputProps) => {
  const [showPassword, setShowPassword] = useState(false);

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <IconInput
      {...props}
      type={showPassword ? 'text' : 'password'}
      endIcon={
        <Button
          type="button"
          variant="ghost"
          size="sm"
          className="h-full px-0 py-0 hover:bg-transparent"
          onClick={togglePasswordVisibility}
          aria-label={showPassword ? 'Hide password' : 'Show password'}
        >
          {showPassword ? (
            <EyeOff className="h-4 w-4" />
          ) : (
            <Eye className="h-4 w-4" />
          )}
        </Button>
      }
    />
  );
};
